import { H2RInput } from "../../imports";
import { H2RSelect } from "../../imports";
import {
	ReplaceWithDataSource,
} from "../helpers/variable";

export const GraphicEditor = ({ cue, onUpdate, encode = false }) => {
	return (
		<>
			<H2RInput
				label="First line (Large text)"
				value={cue.line_one}
				onChange={(value) => {
					onUpdate({
						line_one: value,
					});
				}}
			/>
			<H2RInput
				label="Second line (Small text)"
				value={cue.line_two}
				onChange={(value) => {
					onUpdate({
						line_two: value,
					});
				}}
			/>
			<H2RSelect
				label="Animation"
				selected={cue.animationName}
				onChange={(choice) => {
					onUpdate({ animationName: choice });
				}}
				options={[
					{
						label: "Reveal",
						value: "reveal",
					},
					{
						label: "Unfold",
						value: "unfold",
					},
					{
						label: "Slide out",
						value: "slide-out",
					},
					{
						label: "Stretch",
						value: "stretch",
					},
				]}
			/>
			{/* <H2RCheckbox
				checked={cue.twoLines || false}
				label="Two lines"
				checkboxLabel="Two lines"
				onChange={(change) => {
					onUpdate({ twoLines: change });
				}}
			/> */}
		</>
	);
};

export const GraphicCueContent = ({ cue, twoLines }) => {
	return (
		<div className="overflow-ellipsis w-48 md:w-auto max-w-xs md:max-w-sm lg:max-w-lg whitespace-nowrap overflow-hidden">
			<div className="font-semibold ">
				{<ReplaceWithDataSource text={cue.line_one} keepBrakets={true} styled={true} /> ||
					"Lower third"}
			</div>
			<div
				className={`text-xs text-gray-300
							${twoLines ? "pl-0 block " : ""}
			`}
			>
				{<ReplaceWithDataSource text={cue.line_two} keepBrakets={true} styled={true} />}
			</div>
		</div>
	);
};
